(function () {
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    return 'R ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updatePrice(variantId, productId) {
    const dataEl = document.getElementById('product-variants-json-' + productId);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const variant = variants.find(function(v) { return v.id === variantId; });
    if (!variant) return;
    const container = document.getElementById('price-main-product-' + productId);
    if (!container) return;

    if (!variant.available) {
      container.classList.add('price--sold-out');
    } else {
      container.classList.remove('price--sold-out');
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      container.classList.add('price--on-sale');
      const regularEl = container.querySelector('.price__sale .price-item--regular span');
      if (regularEl) regularEl.textContent = formatMoney(variant.compare_at_price);
      const saleEl = container.querySelector('.price-item--sale span');
      if (saleEl) saleEl.textContent = formatMoney(variant.price);
    } else {
      container.classList.remove('price--on-sale');
      const regularEl = container.querySelector('.price__regular .price-item--regular');
      if (regularEl) regularEl.textContent = formatMoney(variant.price);
      const saleEl = container.querySelector('.price-item--sale span');
      if (saleEl) saleEl.textContent = formatMoney(variant.price);
    }

    // Remove skeleton loading immediately
    container.querySelectorAll('.skeleton-loading').forEach(function(el) {
      el.classList.remove('skeleton-loading');
    });
  }

  // Intercept the fetch that base.js uses to update the price
  var originalFetch = window.fetch;
  window.fetch = function(url) {
    var args = arguments;
    var urlString = typeof url === 'string' ? url : (url && url.url) || '';

    // When base.js fetches the variant page, update price instantly first
    if (urlString.indexOf('?variant=') !== -1 && urlString.indexOf('/cart') === -1 && urlString.indexOf('section_id') === -1) {
      var variantId = parseInt(urlString.split('?variant=')[1]);
      var priceEl = document.querySelector('[id^="price-main-product-"]');
      if (priceEl && variantId) {
        var productId = priceEl.id.replace('price-main-product-', '');
        updatePrice(variantId, productId);
      }
    }

    return originalFetch.apply(this, args);
  };

})();